import AppButton from '../../atoms/AppButton/AppButton'
import PropTypes from 'prop-types'

type DeleteSectionProps = {
    title: string
    description?: string
    titleButton: string
    disabledButton: boolean
    onSubmit: () => void
}

export const DeleteSection: React.FC<DeleteSectionProps> = ({
    title,
    description,
    titleButton,
    disabledButton = false,
    onSubmit,
}) => {
    return (
        <div className="font-sans w-full movile:flex movile:flex-col movile:px-5 movile:gap-5 tablet:grid tablet:grid-cols-1 tablet:px-5 tablet:gap-5 desktop:grid desktop:gap-5 desktop:grid-cols-1 desktop:m-5 desktop:w-12/12 bg-white py-5 px-6 rounded-lg space-y-4 shadow-sm">
            <h3 className="text-xl font-medium text-black-600 ">{title}</h3>
            <p className="text-base text-gray-800 mt-2">{description}</p>
            <div className="font-sans flex movile:justify-center">
                <AppButton
                    title={titleButton}
                    disabled={disabledButton}
                    onClick={onSubmit}
                    state="ghost_secondary"
                />
            </div>
        </div>
    )
}

DeleteSection.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    titleButton: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
}
